// SplashScreen.jsx

import React from 'react';

// Context
import { useStartupStatus } from 'context/StartupStatusContext';
import { useTheme } from 'context/ThemeContext';

// CSS
import './SplashScreen.css';

/**
 * SplashScreen
 *
 * Full-screen startup overlay shown while the app initializes.
 *
 * @returns {ReactNode} The rendered splash screen.
 */
const SplashScreen = () => {

    // ----- HOOKS ----- //

    // Startup Status Context

    const { currentStatusMessage } = useStartupStatus();

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (
        <div
          className="splash-screen-container"
        >
            {currentStatusMessage ? (
                <div
                    style={{
                        color: theme.foregroundMuted,
                        fontSize: '14px',
                        letterSpacing: '0.02em',
                        maxWidth: '420px',
                        padding: '0 24px',
                        textAlign: 'center',
                    }}
                >
                    {currentStatusMessage}
                </div>
            ) : null}
        </div>
    );
};

// Dev Tools
SplashScreen.displayName = 'SplashScreen';

export default SplashScreen;
